var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: {
        placeholder: _vm.$t("basicData.PleaseSelect"),
        clearable: "",
        disabled: _vm.disabled,
      },
      model: {
        value: _vm.val,
        callback: function ($$v) {
          _vm.val = $$v
        },
        expression: "val",
      },
    },
    [
      _c("el-option", {
        key: 1,
        attrs: { label: _vm.$t("collectionCenter.dropOff"), value: 1 },
      }),
      _c("el-option", {
        key: 2,
        attrs: { label: _vm.$t("collectionCenter.doorPickUp"), value: 2 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }